import SearchIcon from '@mui/icons-material/Search';
import { Box, FormControlLabel, InputAdornment, Switch, TextField } from '@mui/material';
import React from 'react';

interface IProps {
  searchQuery: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  showIssuesOnly: boolean;
  onToggleIssuesOnly: (checked: boolean) => void;
}

const SearchAndFilter: React.FC<IProps> = ({ searchQuery, onSearchChange, showIssuesOnly, onToggleIssuesOnly }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <TextField
        placeholder="Search"
        variant="outlined"
        size="small"
        value={searchQuery}
        onChange={onSearchChange}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '4px',
            '& fieldset': {
              borderRadius: '4px',
            },
          },
          width: 286,
        }}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon />
              </InputAdornment>
            ),
          },
        }}
        data-action="search_input"
      />
      <FormControlLabel
        control={<Switch checked={showIssuesOnly} onChange={(e) => onToggleIssuesOnly(e.target.checked)} />}
        sx={{ marginRight: 0 }}
        label="Show issues only"
        data-action="show_issues_only_switch"
      />
    </Box>
  );
};

export default React.memo(SearchAndFilter);
